module.exports = __webpack_public_path__ + "images/sgp/SizeGuide/5x10.svg";